export default __webpack_public_path__ + "static/media/termClock.e3e5772b.svg";